import DateFnsUtils from '@date-io/date-fns';
import {
    KeyboardTimePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import styles from 'styles/modules/newsAlert/InputPicker.module.scss';
import Clock from 'components/Svg/Clock';

const TimePicker = ({ time, setTime, setTimeValid }) => {
    return (
        <div className={styles.wrapper}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardTimePicker
                    ampm={false}
                    value={time}
                    onChange={setTime}
                    className={styles.picker}
                    keyboardIcon={<Clock />}
                    onError={(error) => setTimeValid(!error)}
                />
            </MuiPickersUtilsProvider>
        </div>
    );
};

export default TimePicker;
